<script>
    import { createEventDispatcher } from "svelte";
    import { sgettext } from '../../i18n.js';
    import WarningTooltip from "../common/WarningTooltip.svelte";
    export let users = null;
    export let userType = "PLACEHOLDER-USERTYPE";
    export let noApproversLabel = "";
    export let title = "PLACEHOLDER-TITLE";
    export let tooltipText = null;
    export let readonly = false;
    export let isExpanded = false;
    export let fixedTable = false;
    export let scrollHeight = "300px";
    export let requiredUsers = []

    const dispatch = createEventDispatcher();

    function toggle() {
        isExpanded = !isExpanded;
    }

    function bypassApprover(id, user_id) {
        dispatch('bypass', { id, user_id })
    }

    function regroupApprover(id, user_id, type) {
        dispatch('regroup', { id, user_id, type })
    }
</script>

<div
  style="{fixedTable ? '' : 'background-color: #ddd;'} border-radius: 5px;"
  class="mb-3"
  data-testid="workflow-approvers-container"
>
  {#if users?.length > 0}
    {#if fixedTable}
      {title}
    {:else}
      <div
        class="d-flex justify-content-between justify-align-items px-3 py-2 pointer-cursor"
        on:click={toggle}
        data-testid="title"
      >
        <label class="mb-0 pointer-cursor" 
          >{title}
          <WarningTooltip {tooltipText} />
        </label>
        {#if isExpanded}
          <span data-testid="chevron-expanded"><i class="fa fa-chevron-up" /></span>
        {:else}
          <span data-testid="chevron-collapsed"><i class="fa fa-chevron-down"/></span>
        {/if}
      </div>
    {/if}
  {:else}
    <div class="d-flex justify-align-items pl-3 py-2">
      <label class="mb-0"
        >{noApproversLabel}</label
      >
    </div>
  {/if}

  {#if users}
    <div
      class="{isExpanded ? 'p-1' : ''} scrollable-div"
      style="max-height: {scrollHeight}"
      data-testid="list-container"
    >
      <ul class={isExpanded ? 'list-group' : 'hide'}  data-testid="list">
        {#each users as user (user.user_id + userType + user.id)}
          <li
            data-testid="list-item"
            class="list-group-item d-flex justify-content-between align-items-start py-1 {readonly
              ? 'readonly-item'
              : requiredUsers.includes(user.user_id)
              ? 'required-item'
              : 'regular-list-item'}"
          >
            <div class="ms-2">
              <p class="pb-0 mb-0" data-testid="name"><b>{user.username}</b></p>
              <span class="site-user-position" data-testid="position">{user.position}</span>
              {#if user.type}
                <div class={readonly ? 'no-pointer-events' : ''}>
                  <input
                    type="radio"
                    data-testid="radio-item-individual"
                    id={user.user_id + 'Individual' + user.id}
                    checked={user.type == 'Individual'}
                    name={'reviewer' + user.user_id + user.id}
                    on:change={() =>
                      regroupApprover(user.id, user.user_id, 'Individual')}
                  />
                  <label
                    class="regular-label mr-2"
                    for={user.user_id + 'Individual' + user.id}
                    >{sgettext('$$INDIVIDUAL$$')}
                  </label>
                  <input
                    readonly
                    type="radio"
                    data-testid="radio-item-group"
                    id={user.user_id + 'Group' + user.id}
                    checked={user.type == 'Group'}
                    name={'reviewer' + user.user_id + user.id}
                    on:change={() =>
                      regroupApprover(user.id, user.user_id, 'Group')}
                  />
                  <label
                    class="regular-label"
                    for={user.user_id + 'Group' + user.id}
                    >{sgettext('$$GROUP$$')}
                  </label>
                </div>
              {/if}
            </div>

            {#if !readonly}
              {#if requiredUsers.includes(user.user_id)}
                <span
                  data-testid="readonly-icon"
                  class="px-2 py-1 my-auto bypass-approver"
                  title={fixedTable
                    ? sgettext('$$REMOVE_USER$$')
                    : sgettext('$$NOT_BYPASS_CONTROL_OWNER$$')}
                >
                  <i class="fa fa-info-circle " />
                </span>
              {:else}
                <span
                  data-testid="delete-icon"
                  class="px-2 py-1 my-auto bypass-approver"
                  title={fixedTable
                    ? sgettext('$$REMOVE_USER$$')
                    : userType == 'reviewer'
                    ? sgettext('$$BYPASS_REVIEWER$$')
                    : sgettext('$$BYPASS_CONTROL_OWNER$$')}
                  on:click={() => bypassApprover(user.id, user.user_id)}
                >
                  <i class="fa fa-trash " />
                </span>
              {/if}
            {/if}
          </li>
        {/each}
      </ul>
    </div>
  {/if}
</div>

<style>
  .bypass-approver {
    border-radius: 5px;
  }

  .bypass-approver:hover {
    color: #dd5900;
  }

  .readonly-item {
    background-color: #eee;
  }

  .required-item {
    background-color: #eee;
  }

  .readonly-item:hover {
    cursor: not-allowed;
  }

  .regular-list-item {
    background-color: white;
  }

  .regular-list-item:hover {
    background-color: #f5f5f5;
  }

  .regular-label {
    font-weight: normal;
  }

  .site-user-position {
    color: #888;
    display: block;
    margin-bottom: 0;
  }

  .hide {
    display: none !important;
  }

  .scrollable-div {
    max-height: 300px;
    overflow: auto;
  }

  .pointer-cursor {
    cursor: pointer;
  }

  .no-pointer-events {
    pointer-events: none;
  }
</style>
